import { Component } from '@angular/core';
import {
  IonicPage,
  ModalController,
  NavParams,
  ViewController,
} from 'ionic-angular';

import { Model } from '../../models/vehicle.ops';
import { SelectVehicleMakePage } from './../select-vehicle-make/select-vehicle-make';
import { SelectVehicleModelPage } from './../select-vehicle-model/select-vehicle-model';
import { VehicleMakeModel } from './../../models/vehicle-make';

@IonicPage()
@Component({
  selector: 'page-add-vehicle',
  templateUrl: 'add-vehicle.html',
})
export class AddVehiclePage {
  vin: string;
  license: string;
  serial_number: string;
  selectedMake: VehicleMakeModel;
  selectedModel: Model;
  isLoading = true;
  idInfoComplete: boolean = false;

  readonly MIN_VIN_LENGTH = 6;
  readonly MIN_LICENSE_LENGTH = 4;

  constructor(
    navParams: NavParams,
    private modalCtrl: ModalController,
    private viewCtlr: ViewController
  ) {
    this.vin = navParams.get('vin');
    this.license = navParams.get('license');
    this.serial_number = navParams.get('serial_number');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddVehiclePage');
  }

  // Actions

  didTapDismiss() {
    this.viewCtlr.dismiss();
  }

  didTapDone() {
    this.viewCtlr.dismiss({
      vin: this.vin,
      license: this.license,
      serial_number: this.serial_number,
      vehicle_model_uid: this.selectedModel.uid,
      vehicle_make: this.selectedMake.make,
      vehicle_model: this.selectedModel.model,
    });
  }

  didTapSelectMake() {
    const selectMakeModal = this.modalCtrl.create(SelectVehicleMakePage, {
      modal: true,
    });
    selectMakeModal.present();
    selectMakeModal.onDidDismiss(make => {
      if (make) {
        this.selectedMake = make;
      }
    });
  }

  didTapSelectModel() {
    const modelSelector = this.modalCtrl.create(SelectVehicleModelPage, {
      modal: true,
      make: this.selectedMake,
    });
    modelSelector.present();
    modelSelector.onDidDismiss(model => {
      if (model) {
        this.selectedModel = model;
      }
    });
  }

  checkIdInfoComplete() {
    if (!this.selectedModel) {
      this.idInfoComplete = false;
      return;
    }
    if (this.vin && this.vin.trim().length >= this.MIN_VIN_LENGTH) {
      this.idInfoComplete = true;
    } else if (
      this.license &&
      this.license.trim().length >= this.MIN_LICENSE_LENGTH
    ) {
      this.idInfoComplete = true;
    } else if (this.serial_number && this.serial_number.match(/[0-9]/)) {
      this.idInfoComplete = true;
    } else {
      this.idInfoComplete = false;
    }
  }
}

export interface AddVehicleParams {
  vin: string;
  license: string;
  serial_number?: string;
  vehicle_model_uid: string;
  vehicle_make?: string;
  vehicle_model?: string;
}



// WEBPACK FOOTER //
// ./src/pages/add-vehicle/add-vehicle.ts